import React from 'react';
import { useCulinaryCollectiveContent } from '@/hooks/cdaasHooks/cdaasHelperHooks';
import YouTubeVideo from '../common/YouTubeVideo';
import PageNavigation from '../common/PageNavigation';
import FAQs from './FAQs';
import Hero from './Hero';
import { CulinaryContent } from './interface';
import Partners from './partners';
import Divider from '../common/Divider';

const CulinaryCollectivePage = () => {
  const culinaryContent: CulinaryContent = useCulinaryCollectiveContent();
  const {
    chefProfiles,
    heroImage,
    heroImageAltText,
    intro,
    profiles,
    sectionHeaders,
    title,
    overviewVideoUrl,
    overviewVideoTitle,
  } = culinaryContent;

  const menus = [
    // Chef Partners Menu Section Items
    {
      menuSectionHeader: sectionHeaders.chefPartners,
      items: chefProfiles.map((profile) => ({
        ...profile,
        type: 'chef' as const,
      })),
    },
    ...profiles.map((profile) => ({
      menuSectionHeader: profile.header,
      items: [
        {
          ...profile,
          type: 'partner' as const,
        },
      ],
    })),
    {
      menuSectionHeader: sectionHeaders.faq,
      items: culinaryContent.faqs.map((faq, idx) => ({
        ...faq,
        type: 'faq' as const,
        idx,
        section: sectionHeaders.faq,
      })),
    },
  ];

  return (
    <>
      <div className="tw-mx-auto tw-my-10 tw-grid tw-max-w-screen-x2l tw-grid-cols-1 tw-px-4 md_tw-my-16 md_tw-px-0 lg_tw-grid-cols-12">
        <h1 className="text-align-center color-text-emphasis tw-heading-xl-book tw-col-span-8 tw-col-start-3 tw-font-serif md_tw-heading-4xl-book md_tw-font-serif">
          {title}
        </h1>
      </div>
      <div className="tw-mx-auto tw-max-w-screen-x2l md_tw-px-0 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
        <Hero heroImage={heroImage} heroImageAltText={heroImageAltText} />
      </div>
      <div className="flex flex-align-items-center tw-mx-auto tw-max-w-screen-x2l tw-flex-col tw-px-4 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
        <section className="tw-my-10 tw-grid tw-grid-cols-1 md_tw-my-16 lg_tw-grid-cols-12">
          <div className="tw-col-span-2">
            <PageNavigation menus={menus} />
          </div>
          <div className="tw-col-span-8 tw-grid tw-grid-cols-1 lg_tw-grid-cols-8">
            <div
              className="tw-col-span-6 tw-col-start-2 tw-mb-10 tw-font-sans tw-text-xl md_tw-mb-16 lg_tw-text-2xl"
              dangerouslySetInnerHTML={{ __html: intro }}
            />
            <div className="tw-col-span-8">
              <YouTubeVideo
                videoId={overviewVideoUrl}
                title={overviewVideoTitle}
              />
              <div className="md_tw-grid md_tw-grid-cols-8">
                <Divider />
              </div>
            </div>

            <Partners
              partners={chefProfiles}
              sectionHeader={sectionHeaders.chefPartners}
              type="chef"
            />

            <Partners partners={profiles} type="partner" />

            <div className="tw-col-span-8">
              <FAQs
                faqs={culinaryContent.faqs}
                sectionHeader={sectionHeaders.faq}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CulinaryCollectivePage;
